export default __webpack_public_path__ + "static/media/1.481b896f.png";